import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Tenant\Branch\NodeFilterController::index
* @see app/Http/Controllers/Tenant/Branch/NodeFilterController.php:14
* @route '/nodes/user/filter'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/nodes/user/filter',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeFilterController::index
* @see app/Http/Controllers/Tenant/Branch/NodeFilterController.php:14
* @route '/nodes/user/filter'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeFilterController::index
* @see app/Http/Controllers/Tenant/Branch/NodeFilterController.php:14
* @route '/nodes/user/filter'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeFilterController::index
* @see app/Http/Controllers/Tenant/Branch/NodeFilterController.php:14
* @route '/nodes/user/filter'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

const filter = {
    index: Object.assign(index, index),
}

export default filter